import React from "react";
import { Link } from "react-router-dom";

function Error(props) {
  return (
    <div className="errorholder">
      <h1>Something went wrong.</h1>
      <h3>Please contact to Admin</h3>
    </div>
  );
}

export default Error;
